import { useEffect } from 'react';

/**
 * На iOS PWA клавиатура не ресайзит window, а сдвигает visualViewport вверх.
 * Этот хук отслеживает смещение и пишет его в CSS-переменную --keyboard-offset.
 * Используется в modal-overlay чтобы модал всегда оставался над клавиатурой.
 */
export function useKeyboardOffset() {
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;

    function update() {
      const offset = window.innerHeight - vv.height - vv.offsetTop;
      document.documentElement.style.setProperty(
        '--keyboard-offset',
        `${Math.max(0, offset)}px`
      );
    }

    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    update();

    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
      document.documentElement.style.setProperty('--keyboard-offset', '0px');
    };
  }, []);
}
